import lodash from 'lodash';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';
import { nodeWithArgs, node, toQuery, enumeration, toMutation } from 'common/util/queryHelper';
import { queryGraphQL, mutateGraphQL } from 'common/util/query';

export const LOAD_ROLE_PERMISSIONS = 'LOAD_ROLE_PERMISSIONS';
export const LOADING_ROLE_PERMISSIONS = 'LOADING_ROLE_PERMISSIONS';

export function getRolesPermissions(resourceType) {
    return async (dispatch, getState) => {
        const storeState = getState();
        const institutionId = lodash.get(storeState, 'me.institution.id');

        const permissionRoleQuery = nodeWithArgs('permissionRoles', {
            resourceType: enumeration(resourceType),
            institutionId
        }, [
            'id',
            'name',
            'isSystem',
            node('permissions', [
                'id',
                'feature',
                'action',
                'displayName'
            ])
        ]);

        const eregPermissionQuery = nodeWithArgs('getEregPermissions', {
            resourceType: enumeration(resourceType)
        }, [
            'id',
            'feature',
            'action',
            'displayName',
            'editable'
        ]);

        dispatch({ type: LOADING_ROLE_PERMISSIONS });

        const response = await queryGraphQL(toQuery([permissionRoleQuery, eregPermissionQuery]));
        if (response && response.errors) {
            dispatch(addApplicationMessage('error', `There is an error loading ${resourceType} permissions`));
        } else {
            dispatch({
                type: LOAD_ROLE_PERMISSIONS,
                payload: {
                    permissionRoles: response.data.permissionRoles,
                    eregPermissions: response.data.getEregPermissions,
                }
            });
        }
    };
}

export function savePermissions(data, activeColumnId, resourceType, isNewDoaEnabled = false) {
    return async (dispatch, getState) => {
        const state = getState();
        const permissionRoles = lodash.get(state, 'me.institution.rolesPermissions.permissionRoles', []);
        const prevData = lodash.get(state, 'me.institution.rolesPermissions.data', []);
        const eregPermissions = lodash.get(state, 'me.institution.eregPermissions', []);
        const permissionRole = lodash.find(permissionRoles, { id: activeColumnId });
        const permissionIdsToRevoke = [];
        const permissionIdsToGrant = [];
        const newDoaPermissions = ['Manage Monitors', 'View Monitors', 'Manage Team', 'View Team'];
        prevData.forEach((prevRow, index) => {
            const currentRow = data[index];
            const prevValue = prevRow[permissionRole.name];
            const currentValue = currentRow[permissionRole.name];
            if (!newDoaPermissions.includes(currentRow.action)){
                if (prevValue && !currentValue) {
                    permissionIdsToRevoke.push(currentRow.id);
                }
                if (!prevValue && currentValue) {
                    permissionIdsToGrant.push(currentRow.id);
                }
            }
        });

        if (isNewDoaEnabled) {
            const permissionsToFindAndRevoke = ['Manage Study Users', 'View Study Users'];

            const foundPermissionsToRevoke = eregPermissions
                .filter(permission =>
                    permissionsToFindAndRevoke.includes(permission.displayName)
                )
                .map(permission => permission.id);
            permissionIdsToRevoke.push(...foundPermissionsToRevoke);



            prevData.forEach((prevRow, index) => {
                const currentRow = data[index];
                if (newDoaPermissions.includes(currentRow.action)) {
                    const currentValue = currentRow[permissionRole.name];
                    if (!currentValue) {
                        permissionIdsToRevoke.push(currentRow.id);
                    } else {
                        permissionIdsToGrant.push(currentRow.id);
                    }
                }
            });

        }

        const mutation = toMutation([
            nodeWithArgs('revokeEregPermissionFromRole', {
                permissionRoleId: permissionRole.id,
                permissionIds: permissionIdsToRevoke
            }, [
                'id'
            ]),
            nodeWithArgs('grantEregPermissionToRole', {
                permissionRoleId: permissionRole.id,
                permissionIds: permissionIdsToGrant
            }, [
                'id'
            ])
        ]);

        const response = await mutateGraphQL(mutation);
        if (response && response.errors) {
            dispatch(addApplicationMessage('error', `There was an error while updating ${permissionRole.name} permissions`));
        } else {
            dispatch(getRolesPermissions(resourceType, true));
            dispatch(addApplicationMessage('success', `${permissionRole.name} permissions updated`));
        }
    };
}
